/**
 * Helper to check that everything needed is in place to enable algolia search
 */
const enableAlgolia = () => {
	if (
		! existsInDom(
			document.querySelector( MWC_AIS.dom_selectors.input_selector )
		)
	) {
		console.warn( 'Missing dom element to insert algolia search into.' );

		return false;
	}

	return true;
};

const existsInDom = ( node ) => {
	return node === document.body ? false : document.body.contains( node );
};

export default enableAlgolia;
